export default __webpack_public_path__ + "images/4b1248bc4d7626c5c09e0ce82ad181d8.png";